import { Component, ViewChild, OnInit, ViewEncapsulation, ChangeDetectorRef } from '@angular/core';
import { take } from 'rxjs/operators';
import { ActivatedRoute } from '@angular/router';

import { NavController, NavParams, ModalController } from '@ionic/angular';
import { isEmpty, get, omit, orderBy, values } from 'lodash';
import { Validators, FormBuilder } from '@angular/forms';
import { CreateMessageActions, MyPenmateActions } from '../actions';
import { Namefully } from 'namefully'
import { StripeAddressChangeEvent, StripeAddressComponent } from '../shared/components/stripe-address/stripe-address.component';

import { AppState, LetterService, EventService, mapStates } from '../services';
import { Store } from '@ngrx/store';
/*
  Generated class for the AddReturnAddress page.

  See http://ionicframework.com/docs/v2/components/#navigation for more info on
  Ionic pages and navigation.
*/
@Component({
  selector: 'pm-create-message-return-address',
  templateUrl: 'create-message-return-address.html',
  styleUrls: ['./create-message-return-address.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class CreateMessageReturnAddress implements OnInit {
  @ViewChild('mainContent', { static: false }) mainContent;
  @ViewChild('scrollContent', { static: false }) scrollContent;
  @ViewChild('stripeAddress', { static: false }) stripeAddressComponent: StripeAddressComponent;

  addressType = 'fromUser';
  savedReturnAddress = {};
  returnAddressForm;
  formSubmitted;
  penmate;
  STATE_NAMES;
  currentMessage;
  penmateId;
  addressConfirmation;
  isAddressDataReady = false;

  constructor(
    public navCtrl: NavController,
    public modalCtrl: ModalController,
    public navParams: NavParams,
    public route: ActivatedRoute,
    public eventService: EventService,
    private createMessageActions: CreateMessageActions,
    private myPenmateActions: MyPenmateActions,
    private store: Store<AppState>,
    private cdr: ChangeDetectorRef
  ) {
      this.STATE_NAMES = mapStates.map(m => m['abbreviation']);
      this.penmateId = this.navParams.get('penmateId');
      this.addressConfirmation = this.navParams.get('addressConfirmation');
      this.store.dispatch(this.myPenmateActions.loadMessages(this.penmateId));
      this.store
      .select(state => state.createMessage)
      .subscribe(currentMessage => {
        this.currentMessage = currentMessage;
      });
  }

  onCancel() {
    this.modalCtrl.dismiss();
  }

  ngOnInit() {
    this.store
      .select(state => state)
      .pipe(take(1))
      .subscribe(({ myPenmates: { currentPenmate }, user, createMessage }) => {
        this.currentMessage = createMessage;
        this.penmate = currentPenmate || get(createMessage, 'penmate');
        this.isAddressDataReady = true;
      })
      .unsubscribe();
  }

  onAddressChanged(changeEvent: StripeAddressChangeEvent) {
    this.store
      .select(({ createMessage }) => ({ createMessage }))
      .take(1)
      .subscribe(({ createMessage: currentMessage }) => {
        this.store.dispatch(
          this.createMessageActions.setMessage({
            returnAddress: {
              addressType: 'physical',
              ...(currentMessage.returnAddress || {}),
              ...changeEvent.value,
            },
          }),
        );
      }).unsubscribe();
    
    this.cdr.detectChanges();
  }

  onSaveAndContinue = async () => {
    this.formSubmitted = true;
    
    // Trigger validation to show any errors in the UI
    await this.stripeAddressComponent.triggerValidation();
    
    // Now check if the form is valid
    const isValid = this.stripeAddressComponent.isValid();
    if (!isValid) {
      return;
    }
    this.store.dispatch(this.createMessageActions.saveDraft(this.currentMessage, { st_eligible: true }));
    this.eventService.track('add-return-address', {
      letter_id: this.currentMessage.id,
      penmate_id: get(this.currentMessage, 'penmate.id'),
    });
    await this.modalCtrl.dismiss();
  };
}
